// @noflow
import { httpPost } from '../../helpers/helpers.api';

export default function resetPassword(password, token, email) {
    return httpPost(
        'global/reset-password',
        {
            password,
            token,
            email
        },
        false,
        false
    );
}



// WEBPACK FOOTER //
// ./src/core/api/authentication/reset-password/index.js